"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverIconMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
/** @class PopoverIconMixin */
/** @method */
var PopoverIconMixin = (0, _styledToken.default)('Popover.icon.size', function (size) {
  return (0, _styledComponents.css)(["height:", "px;width:", "px;", "{height:100%;width:100%;}"], size, size, _Icon.StyledIcon);
});
exports.PopoverIconMixin = PopoverIconMixin;